module.exports = __webpack_public_path__ + "media/country_flags/pa-72102d9a.png";